import ReceivableScreen from './index';
import DetailScreen from './detail';
import CreateScreen from './create';
import UpdateScreen from './update';
import DuplicateScreen from './duplicate';

const routes = [
  {
    path: '/receivable',
    component: ReceivableScreen,
  },
  {
    path: '/receivable/create',
    component: CreateScreen,
  },
  {
    path: '/receivable/:id',
    component: DetailScreen,
  },
  {
    path: '/receivable/update/:id',
    component: UpdateScreen,
  },
  {
    path: '/receivable/duplicate/:id',
    component: DuplicateScreen,
  },
];

export default routes;
